var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassMenu",
    {
      ref: "contextmenu-" + _vm.id,
      attrs: {
        trigger: "click",
        "custom-class": "listing-context-menu",
        placement: "left-start"
      },
      on: { open: _vm.handleOpenMenu, close: _vm.handleCloseMenu }
    },
    [
      _c("CompassIconButton", { attrs: { size: "medium", icon: "action" } }),
      _vm._v(" "),
      _c(
        "template",
        { slot: "dropdown" },
        [
          _vm._l(_vm.items, function(item, index) {
            return [
              item.subitems
                ? _c(
                    "CompassMenuGroup",
                    {
                      key: "contextmenu-subitem-" + _vm.id + "-" + index,
                      attrs: {
                        placement: "left-start",
                        label: item.label,
                        disabled: item.disabled
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "dropdown" },
                        _vm._l(item.subitems, function(subitem, subindex) {
                          return _c("CompassMenuItem", {
                            key:
                              "contextmenu-item-" +
                              _vm.id +
                              "-" +
                              index +
                              "-" +
                              subindex,
                            attrs: {
                              label: subitem.label,
                              disabled: subitem.disabled
                            },
                            on: {
                              click: function($event) {
                                return _vm.goto(
                                  subitem.action,
                                  subitem.target,
                                  subitem.type,
                                  _vm.id
                                )
                              }
                            }
                          })
                        }),
                        1
                      )
                    ],
                    2
                  )
                : _c("CompassMenuItem", {
                    key: "contextmenu-item-" + _vm.id + "-" + index,
                    attrs: { disabled: item.disabled, label: item.label },
                    on: {
                      click: function($event) {
                        return _vm.goto(
                          item.action,
                          item.target,
                          item.type,
                          _vm.id
                        )
                      }
                    }
                  })
            ]
          })
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }